import _styled from "styled-components";
import React from "react";
export type PointCloudTopMediaViewProps = {
  media?: React.ReactNode;
};
export function PointCloudTopMediaView({
  media
}: PointCloudTopMediaViewProps) {
  if (!media) {
    return null;
  }
  return <_StyledDiv>{media}</_StyledDiv>;
}
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "point-cloud-top-media___StyledDiv",
  componentId: "sc-ovw2wq-0"
})({
  "position": "relative",
  "aspectRatio": "26/9",
  "borderWidth": "1px",
  "borderColor": "currentColor",
  "@media (min-width: 1024px)": {
    "width": "35.2rem"
  }
});